export const auth0BasePath = 'auth'
export const delegateBasePath = 'delegate'
export const mapboxPlacesBasePath = 'mapbox.places'
